import { FC } from 'react';
import { NavLink } from 'react-router-dom';

import { Home, RefreshCcw } from 'lucide-react';

import Button from '@mui/material/Button';

import { ERRORS_MAP } from './constants';
import { ErrorStatus } from './types';

import css from './ErrorLayout.module.css';

import { AppRoute } from 'v2/routes';

export interface ErrorPageProps {
  status?: ErrorStatus;
}

export const ErrorLayout: FC<ErrorPageProps> = ({ status = 500 }) => {
  const handleRetry = () => {
    window.location.reload();
  };

  return (
    <section className={css.errorPage}>
      <div className={css.errorPageContainer}>
        <p className={css.errorPageStatus}>{status}</p>

        <p className={css.errorPageTitle}>{ERRORS_MAP[status].title}</p>

        <p className={css.errorPageDescription}>{ERRORS_MAP[status].description}</p>

        <div className={css.errorPageActions}>
          {status === 500 ? (
            <Button className={css.errorPageButton} onClick={handleRetry} variant="outlined" startIcon={<RefreshCcw />}>
              Try Again
            </Button>
          ) : (
            <NavLink to={AppRoute.ROOT} replace>
              <Button className={css.errorPageButton} variant="contained" startIcon={<Home />}>
                Go Home
              </Button>
            </NavLink>
          )}
        </div>
      </div>
    </section>
  );
};
